import { orderPromoDetails } from '../../../utils/orderPromoDetails';
import OrderTotals from '../../promo/OrderTotals';
import React, { useState } from 'react';
import { BASE_URL } from '../../../shared/constants';
import { renderPrice } from '../../../utils/adminOrderService';
import { formatPrice } from '../../basket/basketUtils';
import PreOrderBlock from '../../PreOrderBlock';
import ProductDiscountImage from '../../ProductDiscountImage';

const OrderItemsMobile = ({
                            order,
                            items,
                            totalPrice,
                            discountedPrice,
                            setModalImage
                          }) => {
  const [itemsOpened, setItemsOpened] = useState(true);

  if (!items || items.length === 0) return null;

  const finalTotal = order?.finalTotal ?? discountedPrice;
  const hasDiscount = totalPrice > finalTotal;
  const promo = orderPromoDetails(order);

  return (
    <div className="card mb-3">
      <div
        className="card-header p-2 d-flex justify-content-between align-items-center cursor-pointer"
        onClick={() => setItemsOpened(prev => !prev)}
      >
        <h5 className="card-title font-weight-bold m-0">
          🛒 Товари
        </h5>
        <span className="text-muted font-weight-bold">
          {itemsOpened ? '−' : '+'}
        </span>
      </div>

      {/* ===== COLLAPSED SUMMARY ===== */}
      {!itemsOpened && (
        <div className="card-body py-2 d-flex justify-content-between align-items-center bg-light">
          <span className="font-weight-bold">
            {items.length} товар(ів)
          </span>

          {hasDiscount ? (
            <span>
              <span className="text-muted mr-2 text-decoration-line-through">
                {formatPrice(totalPrice)} грн
              </span>
              <span className="font-weight-bold">
                {formatPrice(finalTotal)} грн
              </span>
            </span>
          ) : (
            <span className="font-weight-bold">
              {formatPrice(totalPrice)} грн
            </span>
          )}
        </div>
      )}

      {/* ===== ITEMS LIST ===== */}
      {itemsOpened && (
        <>
          <div className="card-body p-2">
            {items.map((item, index) => (
              <div
                key={index}
                className={`row align-items-center py-2 ${
                  index !== items.length - 1 ? 'border-bottom' : ''
                }`}
              >
                <div className="col-3">
                  {item.image && (
                    <ProductDiscountImage price={item.price} discountedPrice={item.discountedPrice}
                      personalDiscount={item.personalDiscount} productDiscount={item.productDiscount}>
                      <img
                        src={`${BASE_URL}/api/v1/product/image/${item.image}`}
                        alt={item.name}
                        className="img-fluid cursor-pointer"
                        data-toggle="modal"
                        data-target="#imageModalMobile"
                        onClick={() => setModalImage(item.image)}
                      />
                    </ProductDiscountImage>
                  )}
                </div>

                <div className="col-9">
                  <div className="font-weight-bold">
                    {item.name}
                  </div>
                  <div style={{ fontSize: 14 }}>
                    {item.productCode && (
                      <div className="text-muted">Артикул: <b>{item.productCode}</b></div>
                    )}
                {(item.state?.databaseValue === 'PREORDER' || item.toOrder) && (
                      <PreOrderBlock expectedArrivalDate={item.expectedArrivalDate} />
                    )}
                  </div>

                  <div className='d-flex justify-content-center align-items-center pt-2'>
                    {item.quantity} шт
                    <span className='mx-1'>х</span>
                    {renderPrice(item)}
                  </div>

                </div>
              </div>
            ))}
          </div>


        </>
      )}
      <OrderTotals totalPrice={totalPrice} finalTotal={finalTotal} promo={promo} showPromoCode savingsLabel='Загальна економія' />
    </div>
  );
};

export default OrderItemsMobile;
